export const ACTIONS = {
    SIGNUP: 'SIGN_UP',
    LOGIN: 'LOG_IN',
    VERIFY_EMAIL: 'VERIFY_EMAIL',
    UPDATE_USER_ACCOUNT_EMAIL_USERID: 'UPDATE_USER_ACCOUNT_EMAIL_USERID',
    UPDATE_USER_ACCOUNT_ID: 'UPDATE_USER_ACCOUNT_ID'
}